// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as RenderIf$OrcaPaymentPage from "../Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "../CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as VGSHelpers$OrcaPaymentPage from "../Utilities/VGSHelpers.bs.js";
import * as CommonHooks$OrcaPaymentPage from "../Hooks/CommonHooks.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as VGSConstants$OrcaPaymentPage from "../Utilities/VGSConstants.bs.js";
import * as CardThemeType$OrcaPaymentPage from "../Types/CardThemeType.bs.js";
import * as ErrorComponent$OrcaPaymentPage from "../Components/ErrorComponent.bs.js";
import * as VGSInputComponent$OrcaPaymentPage from "../Components/VGSInputComponent.bs.js";
import * as SavedCardCvcStyles$OrcaPaymentPage from "../Utilities/SavedCardCvcStyles.bs.js";

function VGSVault(props) {
  let __cvcOnly = props.cvcOnly;
  let __cvcOnly_value = __cvcOnly !== undefined ? __cvcOnly : false;
  let vaultCredentials = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let localeString = match.localeString;
  let themeObj = match.themeObj;
  let match$1 = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  let parentURL = match$1.parentURL;
  let iframeId = match$1.iframeId;
  let cardFlowType = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.cardFlowType);
  let savedCardBrand = CardUtils$OrcaPaymentPage.normalizeCardBrand(Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.savedCardBrand));
  let match$2 = match.config.appearance;
  let innerLayout = match$2.innerLayout;
  let elementType = CardThemeType$OrcaPaymentPage.getPaymentModeToString(cardFlowType);
  let match$3;
  if (typeof vaultCredentials !== "object" || vaultCredentials.TAG === "HyperswitchVault") {
    match$3 = [
      "",
      ""
    ];
  } else {
    let creds = vaultCredentials._0;
    match$3 = [
      creds.vaultId,
      creds.environment
    ];
  }
  let environment = match$3[1];
  let vaultId = match$3[0];
  let match$4 = React.useState(() => {});
  let setIsCardFocused = match$4[1];
  let match$5 = React.useState(() => {});
  let setIsCVCFocused = match$5[1];
  let isCVCFocused = match$5[0];
  let match$6 = React.useState(() => {});
  let setIsExpiryFocused = match$6[1];
  let match$7 = React.useState(() => {});
  let setForm = match$7[1];
  let form = match$7[0];
  let match$8 = React.useState(() => {});
  let setCardField = match$8[1];
  let cardField = match$8[0];
  let match$9 = React.useState(() => {});
  let setExpiryField = match$9[1];
  let expiryField = match$9[0];
  let match$10 = React.useState(() => {});
  let setCVCField = match$10[1];
  let cvcField = match$10[0];
  let match$11 = React.useState(() => "");
  let setVgsCardError = match$11[1];
  let vgsCardError = match$11[0];
  let match$12 = React.useState(() => "");
  let setVgsExpiryError = match$12[1];
  let vgsExpiryError = match$12[0];
  let match$13 = React.useState(() => "");
  let setVgsCVCError = match$13[1];
  let vgsCVCError = match$13[0];
  let vgsScriptStatus = CommonHooks$OrcaPaymentPage.useScript(VGSConstants$OrcaPaymentPage.vgsScriptURL, undefined, VGSConstants$OrcaPaymentPage.vgsScriptIntegrity, "anonymous");
  let vaultInitializedRef = React.useRef(false);
  let formStateRef = React.useRef({});
  let savedCvcStatusRef = React.useRef(undefined);
  let emitSavedCardCvcStatus = (dict, error) => {
    let cvcState = Core__Option.getOr(Core__Option.flatMap(dict["card_cvc"], Core__JSON.Decode.object), {});
    let empty = Utils$OrcaPaymentPage.getBool(cvcState, "isEmpty", true);
    let valid = Utils$OrcaPaymentPage.getBool(cvcState, "isValid", false);
    savedCvcStatusRef.current = [
      empty,
      valid,
      valid
    ];
    let status = Object.fromEntries([
      [
        "empty",
        empty
      ],
      [
        "complete",
        valid
      ],
      [
        "valid",
        valid
      ],
      [
        "error",
        error
      ]
    ]);
    Utils$OrcaPaymentPage.messageParentWindow(parentURL, [[
        "savedCardCvcStatus",
        status
      ]]);
  };
  React.useEffect(() => {
    VGSHelpers$OrcaPaymentPage.handleVGSField(cardField, setIsCardFocused, setVgsCardError, () => Utils$OrcaPaymentPage.handleOnFocusPostMessage(iframeId, elementType, parentURL), () => Utils$OrcaPaymentPage.handleOnBlurPostMessage(iframeId, elementType, parentURL));
  }, [cardField]);
  React.useEffect(() => {
    VGSHelpers$OrcaPaymentPage.handleVGSField(expiryField, setIsExpiryFocused, setVgsExpiryError, () => Utils$OrcaPaymentPage.handleOnFocusPostMessage(iframeId, elementType, parentURL), () => Utils$OrcaPaymentPage.handleOnBlurPostMessage(iframeId, elementType, parentURL));
  }, [expiryField]);
  React.useEffect(() => {
    VGSHelpers$OrcaPaymentPage.handleVGSField(cvcField, setIsCVCFocused, setVgsCVCError, () => Utils$OrcaPaymentPage.handleOnFocusPostMessage(iframeId, elementType, parentURL), () => Utils$OrcaPaymentPage.handleOnBlurPostMessage(iframeId, elementType, parentURL));
  }, [cvcField]);
  React.useEffect(() => {
    if (__cvcOnly_value) {
      Core__Option.forEach(cvcField, field => field.update({
        validations: VGSConstants$OrcaPaymentPage.savedCardCvcValidations(savedCardBrand)
      }));
    }
  }, [
    __cvcOnly_value,
    cvcField,
    savedCardBrand
  ]);
  let initializeVGSFields = vault => {
    if (!__cvcOnly_value) {
      setCardField(param => vault.field("#vgs-cc-number", VGSConstants$OrcaPaymentPage.cardNumberOptions));
      setExpiryField(param => vault.field("#vgs-cc-expiry", VGSConstants$OrcaPaymentPage.cardExpiryOptions(localeString.expiryPlaceholder)));
    }
    setCVCField(param => vault.field("#vgs-cc-cvc", __cvcOnly_value ? VGSConstants$OrcaPaymentPage.savedCardCvcOptions(savedCardBrand) : VGSConstants$OrcaPaymentPage.cardCvcOptions));
    setForm(param => vault);
  };
  let handleVGSErrors = vgsState => {
    let dict = Utils$OrcaPaymentPage.getDictFromJson(vgsState);
    formStateRef.current = dict;
    let fieldState = fieldName => Core__Option.getOr(Core__Option.flatMap(dict[fieldName], Core__JSON.Decode.object), {});
    if (__cvcOnly_value) {
      emitSavedCardCvcStatus(dict, VGSHelpers$OrcaPaymentPage.vgsErrorHandler(dict, "card_cvc", undefined, localeString));
    } else {
      let hasCardState = Core__Option.isSome(dict["card_number"]);
      let hasExpiryState = Core__Option.isSome(dict["card_exp"]);
      let hasCvcState = Core__Option.isSome(dict["card_cvc"]);
      let cardState = fieldState("card_number");
      let expiryState = fieldState("card_exp");
      let cvcState = fieldState("card_cvc");
      let cardValid = Utils$OrcaPaymentPage.getBool(cardState, "isValid", false);
      let expiryValid = Utils$OrcaPaymentPage.getBool(expiryState, "isValid", false);
      let cvcValid = Utils$OrcaPaymentPage.getBool(cvcState, "isValid", false);
      let empty = Utils$OrcaPaymentPage.getBool(cardState, "isEmpty", true) || Utils$OrcaPaymentPage.getBool(expiryState, "isEmpty", true) || Utils$OrcaPaymentPage.getBool(cvcState, "isEmpty", true);
      let status = Object.fromEntries([
        [
          "complete",
          cardValid && expiryValid && cvcValid
        ],
        [
          "empty",
          empty
        ],
        [
          "isCvcEmpty",
          Utils$OrcaPaymentPage.getBool(cvcState, "isEmpty", true)
        ],
        [
          "isCvcComplete",
          cvcValid
        ],
        [
          "isCardValid",
          cardValid
        ],
        [
          "isExpiryValid",
          expiryValid
        ],
        [
          "isCvcValid",
          cvcValid
        ],
        [
          "hasCardValidationStatus",
          hasCardState
        ],
        [
          "hasExpiryValidationStatus",
          hasExpiryState
        ],
        [
          "hasCvcValidationStatus",
          hasCvcState
        ]
      ]);
      Utils$OrcaPaymentPage.messageParentWindow(parentURL, [[
          "cardFieldStatus",
          status
        ]]);
    }
    let setIfPresent = (setError, errStr) => {
      if (errStr !== "") {
        return setError(param => errStr);
      }
    };
    setIfPresent(setVgsCardError, VGSHelpers$OrcaPaymentPage.vgsErrorHandler(dict, "card_number", undefined, localeString));
    setIfPresent(setVgsExpiryError, VGSHelpers$OrcaPaymentPage.vgsErrorHandler(dict, "card_exp", undefined, localeString));
    setIfPresent(setVgsCVCError, VGSHelpers$OrcaPaymentPage.vgsErrorHandler(dict, "card_cvc", undefined, localeString));
  };
  React.useEffect(() => {
    if (__cvcOnly_value) {
      let match = savedCvcStatusRef.current;
      if (match !== undefined) {
        let status = Object.fromEntries([
          [
            "empty",
            match[0]
          ],
          [
            "complete",
            match[1]
          ],
          [
            "valid",
            match[2]
          ],
          [
            "error",
            vgsCVCError
          ]
        ]);
        Utils$OrcaPaymentPage.messageParentWindow(parentURL, [[
            "savedCardCvcStatus",
            status
          ]]);
      }
    }
  }, [
    __cvcOnly_value,
    vgsCVCError,
    parentURL
  ]);
  React.useEffect(() => {
    switch (vgsScriptStatus) {
      case "error" :
        Utils$OrcaPaymentPage.messageParentWindow(parentURL, [[
            "vgsScriptLoadFailed",
            true
          ]]);
        break;
      case "ready" :
        if (vaultId !== "" && environment !== "" && !vaultInitializedRef.current) {
          vaultInitializedRef.current = true;
          initializeVGSFields(VGSCollect.create(vaultId, environment, handleVGSErrors));
        }
        break;
    }
  }, [
    vaultId,
    environment,
    vgsScriptStatus
  ]);
  let submitCallback = React.useCallback(ev => {
    let json = Utils$OrcaPaymentPage.safeParse(ev.data);
    let confirmDict = Utils$OrcaPaymentPage.getDictFromJson(json);
    let confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(confirmDict);
    let isOuterValid = Utils$OrcaPaymentPage.getBool(confirmDict, "isOuterValid", true);
    if (!confirm.doSubmit) {
      return;
    }
    if (form !== undefined) {
      let stateDict = formStateRef.current;
      if (__cvcOnly_value) {
        let cvcErr = VGSHelpers$OrcaPaymentPage.vgsErrorHandler(stateDict, "card_cvc", true, localeString);
        setVgsCVCError(param => cvcErr);
        emitSavedCardCvcStatus(stateDict, cvcErr);
        if (!(cvcErr === "" && isOuterValid)) {
          if (cvcErr !== "") {
            return VGSHelpers$OrcaPaymentPage.submitUserError(VGSHelpers$OrcaPaymentPage.isFieldEmpty(stateDict, "card_cvc") ? localeString.enterFieldsText : localeString.enterValidDetailsText);
          } else {
            return;
          }
        }
        let emptyPayload = {};
        let onSuccess = (param, data) => {
          let cvcToken = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(data), "card_cvc", "");
          Utils$OrcaPaymentPage.messageParentWindow(parentURL, [
            [
              "savedCardCvcTokenEvent",
              true
            ],
            [
              "cvcToken",
              cvcToken
            ]
          ]);
        };
        let onError = param => Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
        return form.submit("/post", emptyPayload, onSuccess, onError);
      }
      let cardErr = VGSHelpers$OrcaPaymentPage.vgsErrorHandler(stateDict, "card_number", true, localeString);
      let expiryErr = VGSHelpers$OrcaPaymentPage.vgsErrorHandler(stateDict, "card_exp", true, localeString);
      let cvcErr$1 = VGSHelpers$OrcaPaymentPage.vgsErrorHandler(stateDict, "card_cvc", true, localeString);
      setVgsCardError(param => cardErr);
      setVgsExpiryError(param => expiryErr);
      setVgsCVCError(param => cvcErr$1);
      let cardFieldsValid = cardErr === "" && expiryErr === "" && cvcErr$1 === "";
      if (cardFieldsValid && isOuterValid) {
        let emptyPayload$1 = {};
        let onSuccess$1 = (param, data) => {
          let match = VGSHelpers$OrcaPaymentPage.getTokenizedData(data);
          Utils$OrcaPaymentPage.messageParentWindow(parentURL, [
            [
              "vgsTokenEvent",
              true
            ],
            [
              "vgsCardData",
              Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
                [
                  "cardNumber",
                  match[0]
                ],
                [
                  "month",
                  match[1]
                ],
                [
                  "year",
                  match[2]
                ],
                [
                  "cvcNumber",
                  match[3]
                ]
              ])
            ]
          ]);
        };
        let onError$1 = param => Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
        return form.submit("/post", emptyPayload$1, onSuccess$1, onError$1);
      }
      if (cardFieldsValid) {
        return;
      }
      let anyEmpty = VGSHelpers$OrcaPaymentPage.isFieldEmpty(stateDict, "card_number") || VGSHelpers$OrcaPaymentPage.isFieldEmpty(stateDict, "card_exp") || VGSHelpers$OrcaPaymentPage.isFieldEmpty(stateDict, "card_cvc");
      return VGSHelpers$OrcaPaymentPage.submitUserError(anyEmpty ? localeString.enterFieldsText : localeString.enterValidDetailsText);
    }
    console.error("VGS Vault not initialized for submission");
  }, [
    form,
    localeString,
    __cvcOnly_value,
    parentURL
  ]);
  Utils$OrcaPaymentPage.useSubmitPaymentDataFromParent(parentURL, submitCallback);
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: __cvcOnly_value ? JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(VGSInputComponent$OrcaPaymentPage.make, {
            fieldName: "",
            id: "vgs-cc-cvc",
            isFocused: Core__Option.getOr(isCVCFocused, false),
            compact: true,
            height: SavedCardCvcStyles$OrcaPaymentPage.fieldHeight
          }),
          className: "flex flex-col w-full",
          style: {
            gridGap: themeObj.spacingGridColumn
          }
        }) : JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
              condition: innerLayout === "Compressed",
              children: JsxRuntime.jsx("div", {
                children: localeString.cardHeader,
                style: {
                  fontSize: themeObj.fontSizeLg,
                  marginBottom: "5px",
                  opacity: "0.6"
                }
              })
            }),
            JsxRuntime.jsx(VGSInputComponent$OrcaPaymentPage.make, {
              fieldName: localeString.cardNumberLabel,
              id: "vgs-cc-number",
              isFocused: Core__Option.getOr(match$4[0], false),
              errorStr: vgsCardError
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(VGSInputComponent$OrcaPaymentPage.make, {
                    fieldName: localeString.validThruText,
                    id: "vgs-cc-expiry",
                    isFocused: Core__Option.getOr(match$6[0], false),
                    errorStr: vgsExpiryError
                  }),
                  className: innerLayout === "Spaced" ? "w-[47%]" : "w-[50%]"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(VGSInputComponent$OrcaPaymentPage.make, {
                    fieldName: localeString.cvcTextLabel,
                    id: "vgs-cc-cvc",
                    isFocused: Core__Option.getOr(isCVCFocused, false),
                    errorStr: vgsCVCError
                  }),
                  className: innerLayout === "Spaced" ? "w-[47%]" : "w-[50%]"
                })
              ],
              className: "flex flex-row w-full place-content-between",
              style: {
                gridColumnGap: innerLayout === "Spaced" ? themeObj.spacingGridRow : ""
              }
            }),
            JsxRuntime.jsx(ErrorComponent$OrcaPaymentPage.make, {
              cardError: vgsCardError,
              expiryError: vgsExpiryError,
              cvcError: vgsCVCError
            })
          ],
          className: "flex flex-col w-full",
          style: {
            gridGap: themeObj.spacingGridColumn
          }
        }),
      className: "flex flex-col",
      style: {
        gridGap: themeObj.spacingGridColumn
      }
    }),
    className: "animate-slowShow"
  });
}

let make = VGSVault;

let $$default = VGSVault;

export {
  make,
  $$default as default,
}
/* jotai Not a pure module */
